import { DefaultPage } from './';

export default {
  path: 'permission/:version/v',
  name: 'Permission',
  childRoutes: [
    { path: ':projectId', name: 'Permissions', component: DefaultPage, isPrivate: true },
  ],
};
